import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../core/modules/shared.module';

import {LogEntriesComponent} from './log.entries.component';

const routes = [{path: 'users/:id/log.entries', component: LogEntriesComponent}];

@NgModule({
  declarations: [LogEntriesComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [LogEntriesComponent]
})

export class LogEntriesModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/log.entries/log.entries.module.ts